/*
 * サブシステム名：取引先別帳票出力
 * 機能名：取引先別帳票出力
 */
import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'

import validators from '@/rahmen/validators'
import filter from '@/rahmen/utils/filters'
import date from '@/ddv2.library/date'
import header from '@/ddv2.library/header'
import message from '@/ddv2.library/messages'

import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'

import DdAutocompleteChipBox from '@/components/DdAutocompleteChipBox.vue'
import DdCodeTextBox from '@/components/DdCodeTextBox.vue'
import DdDateBox from '@/components/DdDateBox'
import DdDateRangeBox from '@/components/DdDateRangeBox'
import DdMonthRangeBox from '@/components/DdMonthRangeBox'
import DdRadioButton from '@/components/DdRadioButton'
import DdSubHeader from '@/components/DdSubHeader'
import DdTextBox from '@/components/DdTextBox.vue'

export default {
  name: 'TorihikisakibetsuOutput',
  mixins: [flowMixin],
  components: {
    DdAutocompleteChipBox,
    DdCustomButton,
    DdTransparentButton,
    DdCodeTextBox,
    DdDateBox,
    DdDateRangeBox,
    DdMonthRangeBox,
    DdRadioButton,
    DdSubHeader,
    DdTextBox
  },
  data: () => ({
    conditions: {},
    copyCon: {},
    dispZandakaChohyo: '',
    chohyoSbt: '0',
    modeKengen: 0,
    // 表示制御
    dispCsvNm: '',
    dispPdfNm: '',
    page: 1,
    // ----------------------------------------------------------------------------------------------------
    // オートコンプリート定義
    // ----------------------------------------------------------------------------------------------------
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    // ----------------------------------------------------------------------------------------------------
    // 表示制御
    // ----------------------------------------------------------------------------------------------------
    daySbtDisp: false,
    dayDisp: false,
    ymDisp: false,
    yDisp: false,
    eigyoshoDisp: false,
    tokuisakiDisp: false,
    seikyuTomeSbtDisp: false,
    yoshasakiDisp: false,
    unchinKakuteiSbtDisp: false,
    seikyuTomeSbtReadOnly: true,
    hacchusakiDisp: false,
    seikyusakiDisp: false,
    shiharaisakiDisp: false
  }),
  watch: {
    chohyoSbt: function () {
      if (this.chohyoSbt === '0') {
        // 売上明細表
        this.daySbtDisp = true
        this.dayDisp = true
        this.ymDisp = false
        this.yDisp = false
        this.eigyoshoDisp = true
        this.tokuisakiDisp = true
        this.seikyuTomeSbtDisp = true
        this.yoshasakiDisp = false
        this.unchinKakuteiSbtDisp = true
        this.hacchusakiDisp = false
        this.seikyusakiDisp = false
        this.shiharaisakiDisp = false
        this.seikyuTomeSbtReadOnly = false
      } else if (this.chohyoSbt === '1') {
        // 得意先別売上集計表
        this.conditions.daySbt = '01'
        this.daySbtDisp = false
        this.dayDisp = false
        this.ymDisp = true
        this.yDisp = false
        this.eigyoshoDisp = true
        this.tokuisakiDisp = true
        this.seikyuTomeSbtDisp = true
        this.yoshasakiDisp = false
        this.unchinKakuteiSbtDisp = false
        this.hacchusakiDisp = false
        this.seikyusakiDisp = false
        this.shiharaisakiDisp = false
        this.seikyuTomeSbtReadOnly = true
      } else if (this.chohyoSbt === '2') {
        // 得意先別売上日計表
        this.conditions.daySbt = '01'
        this.daySbtDisp = false
        this.dayDisp = false
        this.ymDisp = true
        this.yDisp = false
        this.eigyoshoDisp = true
        this.tokuisakiDisp = true
        this.seikyuTomeSbtDisp = true
        this.yoshasakiDisp = false
        this.unchinKakuteiSbtDisp = false
        this.hacchusakiDisp = false
        this.seikyusakiDisp = false
        this.shiharaisakiDisp = false
        this.seikyuTomeSbtReadOnly = true
      } else if (this.chohyoSbt === '3') {
        // 得意先別年間売上対比表
        this.conditions.daySbt = '01'
        this.daySbtDisp = false
        this.dayDisp = false
        this.ymDisp = false
        this.yDisp = true
        this.eigyoshoDisp = true
        this.tokuisakiDisp = true
        this.seikyuTomeSbtDisp = true
        this.yoshasakiDisp = false
        this.unchinKakuteiSbtDisp = false
        this.hacchusakiDisp = false
        this.seikyusakiDisp = false
        this.shiharaisakiDisp = false
        this.seikyuTomeSbtReadOnly = true
      } else if (this.chohyoSbt === '4') {
        // 傭車先下払明細表
        this.daySbtDisp = true
        this.dayDisp = true
        this.ymDisp = false
        this.yDisp = false
        this.eigyoshoDisp = true
        this.tokuisakiDisp = false
        this.seikyuTomeSbtDisp = true
        this.yoshasakiDisp = true
        this.unchinKakuteiSbtDisp = true
        this.hacchusakiDisp = false
        this.seikyusakiDisp = false
        this.shiharaisakiDisp = false
        this.seikyuTomeSbtReadOnly = false
      } else if (this.chohyoSbt === '5') {
        // 傭車先下払集計表
        this.conditions.daySbt = '01'
        this.daySbtDisp = false
        this.dayDisp = false
        this.ymDisp = true
        this.yDisp = false
        this.eigyoshoDisp = true
        this.tokuisakiDisp = false
        this.seikyuTomeSbtDisp = false
        this.yoshasakiDisp = true
        this.unchinKakuteiSbtDisp = true
        this.hacchusakiDisp = false
        this.seikyusakiDisp = false
        this.shiharaisakiDisp = false
        this.seikyuTomeSbtReadOnly = true
      } else if (this.chohyoSbt === '6') {
        // 取引先別発注明細表
        this.daySbtDisp = false
        this.dayDisp = true
        this.ymDisp = false
        this.yDisp = false
        this.eigyoshoDisp = true
        this.tokuisakiDisp = false
        this.seikyuTomeSbtDisp = false
        this.yoshasakiDisp = false
        this.unchinKakuteiSbtDisp = false
        this.hacchusakiDisp = true
        this.seikyusakiDisp = false
        this.shiharaisakiDisp = false
        this.seikyuTomeSbtReadOnly = true
      } else if (this.chohyoSbt === '7') {
        // 取引先別年間発注対比表
        this.conditions.daySbt = '01'
        this.daySbtDisp = false
        this.dayDisp = false
        this.ymDisp = false
        this.yDisp = true
        this.eigyoshoDisp = true
        this.tokuisakiDisp = false
        this.seikyuTomeSbtDisp = false
        this.yoshasakiDisp = false
        this.unchinKakuteiSbtDisp = false
        this.hacchusakiDisp = true
        this.seikyusakiDisp = false
        this.shiharaisakiDisp = false
        this.seikyuTomeSbtReadOnly = true
      } else if (this.chohyoSbt === '8') {
        // 売掛残高一覧表
        this.conditions.daySbt = '01'
        this.daySbtDisp = false
        this.dayDisp = false
        this.ymDisp = true
        this.yDisp = false
        this.eigyoshoDisp = false
        this.tokuisakiDisp = false
        this.seikyuTomeSbtDisp = false
        this.yoshasakiDisp = false
        this.unchinKakuteiSbtDisp = false
        this.hacchusakiDisp = false
        this.seikyusakiDisp = true
        this.shiharaisakiDisp = false
        this.seikyuTomeSbtReadOnly = true
      } else if (this.chohyoSbt === '9') {
        // 売掛残高推移表
        this.conditions.daySbt = '01'
        this.daySbtDisp = false
        this.dayDisp = false
        this.ymDisp = true
        this.yDisp = false
        this.eigyoshoDisp = false
        this.tokuisakiDisp = false
        this.seikyuTomeSbtDisp = false
        this.yoshasakiDisp = false
        this.unchinKakuteiSbtDisp = false
        this.hacchusakiDisp = false
        this.seikyusakiDisp = true
        this.shiharaisakiDisp = false
        this.seikyuTomeSbtReadOnly = true
      } else if (this.chohyoSbt === '10') {
        // 買掛残高一覧表
        this.conditions.daySbt = '01'
        this.daySbtDisp = false
        this.dayDisp = false
        this.ymDisp = true
        this.yDisp = false
        this.eigyoshoDisp = false
        this.tokuisakiDisp = false
        this.seikyuTomeSbtDisp = false
        this.yoshasakiDisp = false
        this.unchinKakuteiSbtDisp = false
        this.hacchusakiDisp = false
        this.seikyusakiDisp = false
        this.shiharaisakiDisp = true
        this.seikyuTomeSbtReadOnly = true
      }
    },
    // 請求止めのReadOnlyが変わった時の対処
    seikyuTomeSbtReadOnly (newVal) {
      if (newVal) {
        this.conditions.seikyuTomeSbt = '01'
      } else {
        this.conditions.seikyuTomeSbt = '99'
      }
    }
  },
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      eigyoshoList: 'DDMasters/mstEigyosho',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      eigyoshoLockFlg: 'users/anotherEigyoshoCtrlFlg',
      userEigyoshoCd: 'users/eigyoshoCd'
    }),
    eigyoshoReadOnly () {
      const self = this
      return !self.eigyoshoLockFlg
    },
    // 営業所マスタフィルター --> ここから
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn === '01'
      })
    },
    filteredEigyoshoListArray () {
      var defArray = []
      const resultArray = this.filteredEigyoshoList.map(elem => {
        return {
          value: elem.eigyoshoCd,
          text: elem.eigyoshoNm
        }
      })
      return defArray.concat(resultArray)
    },
    // 営業所マスタフィルター <-- ここまで
    // 取引先マスタフィルター --> ここから
    filteredMstTorihikisaki () {
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    filteredMstTokuisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.tokuisakiFlg === true
      })
    },
    filteredMstTokuisakiListArray () {
      var defArray = []
      const resultArray = this.filteredMstTokuisakiList.map(elem => {
        return {
          value: elem.torihikisakiCd,
          text: elem.torihikisakiNm
        }
      })
      return defArray.concat(resultArray)
    },
    filteredMstHacchusakiList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.hacchusakiFlg === true
      })
    },
    filteredMstHacchusakiListArray () {
      var defArray = []
      const resultArray = this.filteredMstHacchusakiList.map(elem => {
        return {
          value: elem.torihikisakiCd,
          text: elem.torihikisakiNm
        }
      })
      return defArray.concat(resultArray)
    }
    // 取引先マスタフィルター <-- ここまで
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteLeaveByMenu: function (next) {
    const option = {
      nextCallback: next
    }
    this.preventTransition(option)
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        conditions: this.conditions
      }
    },
    initialize () {
      console.log('initialize')
      const self = this
      const option = {
        loadMasters: ['msteigyosho', 'msttorihikisaki'],
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.initBindVariables()
            resolve()
          })
        },
        savedInputRestorePromise: function (c) {
          return new Promise((resolve) => {
            console.log('savedInputRestorePromise')
            // ユーザ保存項目の復元
            resolve()
          })
        },
        existsIdMethod: () => {
          return false
        },
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            console.log('★★★settingButtonStatePromise★★★', kengen.kengenKbn)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            resolve()
          })
        }
      }
      console.info('call initializeForRegister', this.initializeForRegister, option)
      this.initializeForRegister(option)
    },
    settingStartYm: function (p) {
      this.$set(this.conditions, 'startYm', p)
    },
    settingEndYm: function (p) {
      this.$set(this.conditions, 'endYm', p)
    },
    onCsvButtonClick: function (e) {
      if (!this.clientValidate()) { return }
      this.Effects.loadStart()
      this.clearSummaryMessage()
      let post = ''
      if (this.chohyoSbt === '0') {
        this.dispCsvNm = `売上明細表_${this.getTimeStamp()}.csv`
        post = '/api/v1/vwCD2bzmp0010/CsvDownload'
      } else if (this.chohyoSbt === '1') {
        this.dispCsvNm = `得意先別売上集計表_${this.getTimeStamp()}.csv`
        post = '/api/v1/vwCD2bzmp0020/CsvDownload'
      } else if (this.chohyoSbt === '2') {
        this.dispCsvNm = `得意先別売上日計表_${this.getTimeStamp()}.csv`
        post = '/api/v1/vwCD2bzmp0030/CsvDownload'
      } else if (this.chohyoSbt === '3') {
        this.dispCsvNm = `得意先別年間売上対比表_${this.getTimeStamp()}.csv`
        post = '/api/v1/vwCD2bzmp0040/CsvDownload'
      } else if (this.chohyoSbt === '4') {
        this.dispCsvNm = `傭車先下払明細表_${this.getTimeStamp()}.csv`
        post = '/api/v1/vwCD2bzmp0510/CsvDownload'
      } else if (this.chohyoSbt === '5') {
        this.dispCsvNm = `傭車先下払集計表_${this.getTimeStamp()}.csv`
        post = '/api/v1/vwCD2bzmp0520/CsvDownload'
      } else if (this.chohyoSbt === '6') {
        this.dispCsvNm = `取引先別発注明細表_${this.getTimeStamp()}.csv`
        post = '/api/v1/vwCD2bzmp0610/CsvDownload'
      } else if (this.chohyoSbt === '7') {
        this.dispCsvNm = `取引先別年間発注対比表_${this.getTimeStamp()}.csv`
        post = '/api/v1/vwCD2bzmp0620/CsvDownload'
      } else if (this.chohyoSbt === '8') {
        this.copyCon = Object.assign({}, this.conditions)
        this.conditions = {}
        this.conditions = {
          urikakeZandakaSbt: '0',
          searchSeikyuYm: '',
          shukeiYmFromString: this.copyCon.startYm,
          shukeiYmToString: this.copyCon.endYm,
          startSeikyusakiCd: this.copyCon.startSeikyusakiCd,
          endSeikyusakiCd: this.copyCon.endSeikyusakiCd
        }
        this.dispCsvNm = `売掛残高一覧表_${this.getTimeStamp()}.csv`
        post = '/api/v1/vwCD2bcld0050/Download'
      } else if (this.chohyoSbt === '9') {
        this.copyCon = Object.assign({}, this.conditions)
        this.conditions = {}
        this.conditions = {
          urikakeZandakaSbt: '',
          searchSeikyuYm: '',
          shukeiYmFromString: this.copyCon.startYm,
          shukeiYmToString: this.copyCon.endYm,
          startSeikyusakiCd: this.copyCon.startSeikyusakiCd,
          endSeikyusakiCd: this.copyCon.endSeikyusakiCd
        }
        this.dispCsvNm = `売掛残高推移表_${this.getTimeStamp()}.csv`
        post = '/api/v1/vwCD2bcld0050/Download'
      } else if (this.chohyoSbt === '10') {
        this.dispCsvNm = `買掛残高一覧表_${this.getTimeStamp()}.csv`
        this.copyCon = Object.assign({}, this.conditions)
        this.conditions = {}
        this.conditions = {
          shukeiYmFromString: this.copyCon.startYm,
          shukeiYmToString: this.copyCon.endYm,
          startShiharaisakiCd: this.copyCon.startShiharaisakiCd,
          endShiharaisakiCd: this.copyCon.endShiharaisakiCd
        }
        post = '/api/v1/vwCD2payp0100/Download'
      }
      this.HttpClient
        .post(post, this.conditions)
        .then((data) => {
          if (this.chohyoSbt === '8' || this.chohyoSbt === '9' || this.chohyoSbt === '10') {
            this.conditions = Object.assign({}, this.copyCon)
          }
          const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
          const blob = new Blob([bom, data], { type: 'text/csv' })
          const elem = document.getElementById('csvDownload')
          elem.href = window.URL.createObjectURL(blob)
          elem.click()
          this.setInvalidSummaryMessage('COMI0006')
          this.Effects.loadComplete()
        })
    },
    onPdfButtonClick: function (e) {
      if (!this.clientValidate()) { return }
      this.clearSummaryMessage()
      console.log(e)
      this.Effects.loadStart()
      let post = ''
      if (this.chohyoSbt === '0') {
        this.dispPdfNm = `売上明細表_${this.getTimeStamp()}.pdf`
        post = '/api/v1/vwCD2bzmp0010/PdfDownload'
      } else if (this.chohyoSbt === '1') {
        this.dispPdfNm = `得意先別売上集計表_${this.getTimeStamp()}.pdf`
        post = '/api/v1/vwCD2bzmp0020/PdfDownload'
      } else if (this.chohyoSbt === '2') {
        this.dispPdfNm = `得意先別売上日計表_${this.getTimeStamp()}.pdf`
        post = '/api/v1/vwCD2bzmp0030/PdfDownload'
      } else if (this.chohyoSbt === '3') {
        this.dispPdfNm = `得意先別年間売上対比表_${this.getTimeStamp()}.pdf`
        post = '/api/v1/vwCD2bzmp0040/PdfDownload'
      } else if (this.chohyoSbt === '4') {
        this.dispPdfNm = `傭車先下払明細表_${this.getTimeStamp()}.pdf`
        post = '/api/v1/vwCD2bzmp0510/PdfDownload'
      } else if (this.chohyoSbt === '5') {
        this.dispPdfNm = `傭車先下払集計表_${this.getTimeStamp()}.pdf`
        post = '/api/v1/vwCD2bzmp0520/PdfDownload'
      } else if (this.chohyoSbt === '6') {
        this.dispPdfNm = `取引先別発注明細表_${this.getTimeStamp()}.pdf`
        post = '/api/v1/vwCD2bzmp0610/PdfDownload'
      } else if (this.chohyoSbt === '7') {
        this.dispPdfNm = `取引先別年間発注対比表_${this.getTimeStamp()}.pdf`
        post = '/api/v1/vwCD2bzmp0620/PdfDownload'
      } else if (this.chohyoSbt === '8') {
        this.copyCon = Object.assign({}, this.conditions)
        this.conditions = {}
        this.conditions = {
          urikakeZandakaSbt: '0',
          searchSeikyuYm: '',
          shukeiYmFromString: this.copyCon.startYm,
          shukeiYmToString: this.copyCon.endYm,
          startSeikyusakiCd: this.copyCon.startSeikyusakiCd,
          endSeikyusakiCd: this.copyCon.endSeikyusakiCd
        }
        this.dispPdfNm = `売掛残高一覧表_${this.getTimeStamp()}.pdf`
        post = '/api/v1/vwCD2bcld0050/ChohyoPrint'
      } else if (this.chohyoSbt === '9') {
        this.copyCon = Object.assign({}, this.conditions)
        this.conditions = {}
        this.conditions = {
          urikakeZandakaSbt: '',
          searchSeikyuYm: '',
          shukeiYmFromString: this.copyCon.startYm,
          shukeiYmToString: this.copyCon.endYm,
          startSeikyusakiCd: this.copyCon.startSeikyusakiCd,
          endSeikyusakiCd: this.copyCon.endSeikyusakiCd
        }
        this.dispPdfNm = `売掛残高推移表_${this.getTimeStamp()}.pdf`
        post = '/api/v1/vwCD2bcld0050/ChohyoPrint'
      } else if (this.chohyoSbt === '10') {
        this.copyCon = Object.assign({}, this.conditions)
        this.conditions = {}
        this.conditions = {
          shukeiYmFromString: this.copyCon.startYm,
          shukeiYmToString: this.copyCon.endYm,
          startShiharaisakiCd: this.copyCon.startShiharaisakiCd,
          endShiharaisakiCd: this.copyCon.endShiharaisakiCd
        }
        this.dispPdfNm = `買掛残高一覧表_${this.getTimeStamp()}.pdf`
        post = '/api/v1/vwCD2payp0100/ChohyoPrint'
      }
      this.HttpClient
        .requestFileByPost(post, this.conditions).then(data => {
          if (this.chohyoSbt === '8' || this.chohyoSbt === '9' || this.chohyoSbt === '10') {
            this.conditions = Object.assign({}, this.copyCon)
          }
          // aタグにファイル仕込んでClickする処理
          if (data.type === 'application/pdf') {
            const blob = new Blob([data], { type: 'application/pdf' })
            const elem = document.getElementById('pdfDownload')
            elem.href = window.URL.createObjectURL(blob)
            elem.click()
            this.setInvalidSummaryMessage('COMI0007')
            this.Effects.loadComplete()
          } else {
            this.setInvalidSummaryMessage('COMI0101')
            this.Effects.loadComplete()
          }
        })
    },
    clientValidate: function () {
      var msg
      var startYmd
      var endYmd
      if (this.dayDisp) {
        if (!this.conditions.startDay) {
          this.$refs.startDay[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
          return false
        }
        if (this.conditions.startDay && this.conditions.endDay) {
          msg = validators.compareDate(this.conditions.startDay, this.conditions.endDay)
          if (msg !== undefined) {
            this.$refs.startDay[this.Ctrls.SET_INVALID_METHOD](msg)
            this.$refs.endDay[this.Ctrls.SET_INVALID_METHOD](msg)
            return false
          }
        }
      }
      if (this.ymDisp) {
        if (!this.conditions.startYm) {
          this.$refs.startYm[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
          return false
        }
        if (this.conditions.startYm && this.conditions.endYm) {
          startYmd = Date.parse(this.conditions.startYm + '/01')
          endYmd = Date.parse(this.conditions.endYm + '/01')
          msg = validators.compareDate(startYmd, endYmd)
          if (msg !== undefined) {
            this.$refs.startYm[this.Ctrls.SET_INVALID_METHOD](msg)
            this.$refs.endYm[this.Ctrls.SET_INVALID_METHOD](msg)
            return false
          }
        }
      }
      if (this.yDisp) {
        if (!this.conditions.startY) {
          this.$refs.startY[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
          return false
        }
        if (this.conditions.startY && this.conditions.endY) {
          startYmd = Date.parse(this.conditions.startY + '/01/01')
          endYmd = Date.parse(this.conditions.endY + '/01/01')
          msg = validators.compareDate(startYmd, endYmd)
          if (msg !== undefined) {
            this.$refs.startY[this.Ctrls.SET_INVALID_METHOD](msg)
            this.$refs.endY[this.Ctrls.SET_INVALID_METHOD](msg)
            return false
          }
        }
      }
      return true
    },
    onClearButtonClick: function () {
      this.initBindVariables()
    },
    // ----------------------------------------------------------------------------------------------------
    // 内部共通関数
    // ----------------------------------------------------------------------------------------------------
    initBindVariables: function () {
      var today = new Date()
      // 前月とする為、getMonthの+1は不要
      var togetsu = ('000' + today.getFullYear()).slice(-4) + '/' + ('0' + (today.getMonth())).slice(-2)
      var year = ('000' + today.getFullYear()).slice(-4)
      const startDay = date.getFirstDate(today.getFullYear(), today.getMonth())
      const endDay = date.getLastDate(today.getFullYear(), today.getMonth())
      this.conditions = {
        daySbt: '01',
        seikyuTomeSbt: '99',
        unchinKakuteiSbt: '99',
        startDay: startDay,
        endDay: endDay,
        startYm: togetsu,
        endYm: togetsu,
        startY: year,
        endY: year,
        startEigyoshoCd: null,
        endEigyoshoCd: null,
        startTokuisakiCd: null,
        endTokuisakiCd: null,
        startYoshasakiCd: null,
        endYoshasakiCd: null,
        startHacchusakiCd: null,
        endHacchusakiCd: null,
        startSeikyusakiCd: null,
        endSeikyusakiCd: null,
        startShiharaisakiCd: null,
        endShiharaisakiCd: null,
        eigyoshoCdList: [],
        tokuisakiCdList: [],
        yoshasakiCdList: [],
        hacchusakiCdList: [],
        seikyusakiCdList: [],
        shiharaisakiCdList: []
      }
      this.conditions.eigyoshoCdList[0] = this.userEigyoshoCd
      // 表示制御
      this.chohyoSbt = '0'
      this.daySbtDisp = true
      this.dayDisp = true
      this.ymDisp = false
      this.yDisp = false
      this.eigyoshoDisp = true
      this.tokuisakiDisp = true
      this.seikyuTomeSbtDisp = true
      this.yoshasakiDisp = false
      this.unchinKakuteiSbtDisp = true
      this.seikyuTomeSbtReadOnly = false
      this.hacchusakiDisp = false
      this.seikyusakiDisp = false
      this.shiharaisakiDisp = false
    },
    getTimeStamp () {
      var date = new Date()
      const Y = date.getFullYear()
      const M = ('00' + (date.getMonth() + 1)).slice(-2)
      const D = ('00' + date.getDate()).slice(-2)
      const h = ('00' + date.getHours()).slice(-2)
      const m = ('00' + date.getMinutes()).slice(-2)
      const s = ('00' + date.getSeconds()).slice(-2)

      return Y + M + D + h + m + s
    }
  }
}
